import { Frames } from 'frames-react';
import { ModalName, PaymentStatus } from '@share/enums';
import { payment } from '@state/private';
import { toggleBootstrapModal } from '@util/helper';
import { useAPI } from 'src/hooks';
import { useDebouncedCallback } from 'use-debounce';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { web3 } from '@state/web3';
import CheckoutPaymentFrame from '@com/payment/CheckoutPaymentFrame';

function CheckoutPaymentModal() {
  /* Define state / hook */
  const [isPaying, setIsPaying] = useState(false);
  const [paymentResult, setPaymentResult] = useState<any>();
  const [error, setError] = useState<string>();
  const { getAddress } = web3.useContainer();
  const { paymentModalData: data } = payment.useContainer();
  const { processCheckoutMint } = useAPI();
  const { t } = useTranslation();

  /* Custom Data Object for render or other usages */
  const errMsg: Record<string, string> = {
    'Card form invalid': t('payment.cardInvalid'),
  };

  /* render control function / logic */
  const handleSubmit = useDebouncedCallback(
    async () => {
      const paymentError = (msg?: string) => {
        setError(msg || t('payment.failed'));
        setIsPaying(false);
      };

      setError(undefined);
      setIsPaying(true);
      let result = paymentResult;
      if (!result)
        try {
          result = await Frames.submitCard();
          setPaymentResult(result);
        } catch (err: unknown) {
          paymentError(typeof err === 'string' ? errMsg[err] : undefined);
          return;
        }
      if (result?.token && data) {
        try {
          const response = await processCheckoutMint({
            uuid: data.uuid,
            cardToken: result.token,
            walletAddress: getAddress(),
            amount: data.amount,
            phase: data.phaseId,
            totalPrice: data.totalPrice,
          });
          if (response?.type === PaymentStatus.NEED_AUTHENTICATION)
            window.location.href = response?.link;
          else paymentError();
        } catch (err: any) {
          setIsPaying(false);
        }
      } else paymentError();
    },
    500,
    { leading: true, trailing: false }
  );

  /* Styling */

  /* Render */
  return (
    <div
      aria-hidden
      className="modal popup fade"
      id={ModalName.SELECT_PAYMENT}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <button
            className="close"
            type="button"
            onClick={() => {
              if (!isPaying) toggleBootstrapModal(ModalName.SELECT_PAYMENT);
            }}
          >
            <span aria-hidden>&times;</span>
          </button>
          <div className="modal-body space-y-20 pd-40">
            <h3>{t('modal.paymentInfo')}</h3>
            <hr />
            <CheckoutPaymentFrame
              config={data?.config}
              errorMsg={error}
              handleSubmit={handleSubmit}
              isPaying={isPaying}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
export default CheckoutPaymentModal;
